import { ISavedFilter } from '../../../components/sidebar-filters/saved-filter/interface';
import { SavedFiltersList } from '../../../components/sidebar-filters/SavedFiltersList';
import { useReadinessTrackingSidebarFiltersContext } from './ReadinessTrackingSidebarFiltersContext';

interface IReadinessTrackingSidebarSavedProps {
    onOpenSaveFiltersModal: (filter: ISavedFilter) => void;
}

export const ReadinessTrackingSidebarSaved: React.FC<IReadinessTrackingSidebarSavedProps> = ({ onOpenSaveFiltersModal }) => {
    const { savedFilters, appliedSavedFilter, handleApplySavedFilter, handleDeleteSavedFilter, handleSavedFilterSelect, selectedSavedFilter } =
        useReadinessTrackingSidebarFiltersContext();

    const onDeleteSavedFilter = async (filter: ISavedFilter) => {
        await handleDeleteSavedFilter(filter);

        if (selectedSavedFilter?.id === filter.id) {
            handleSavedFilterSelect(null);
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: '100%',
            }}
        >
            <SavedFiltersList
                savedFilters={savedFilters}
                appliedSavedFilter={appliedSavedFilter}
                onOpenSaveFiltersModal={onOpenSaveFiltersModal}
                onDeleteSavedFilter={onDeleteSavedFilter}
                onApplySavedFilter={handleApplySavedFilter}
            />
        </div>
    );
};
